export enum ScopesEnum {
    SCOPE_NOTES_READ      = 'notes:read',
    SCOPE_NOTES_WRITE     = 'notes:write',
    SCOPE_NOTES_FINALIZE  = 'notes:finalize',
    SCOPE_REVIEW_READ     = 'review:read',
    SCOPE_REVIEW_WRITE    = 'review:write',
    SCOPE_BUILDERS_READ   = 'builders:read',
    SCOPE_BUILDERS_WRITE  = 'builders:write'
}
